export default __webpack_public_path__ + "static/media/Sobre-aille-clinic.724bf979.webp";